import { act } from 'react'
import * as actions from './betaStationConstant.js'
const initialState = {
    betStationResp: {},
    isBetaBannerClosed: false,
}

const betaStationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.GET_BETA_STATION_SUCCESS: {
            return {
                ...state,
                betStationResp: action.data,
            }
        }
        case actions.SET_BETA_BANNER_CLOSED: {
            return {
            ...state,
            isBetaBannerClosed: action.isBetaBannerClosed
            }
        }
        default:
            return state;
    }
}


export default betaStationReducer;
